import { Card, Input, LearnMoreLink, Text } from '@ui/themed';
import { t } from 'i18next';
import { SETTING_KEY_TO_LABEL } from '../../constants';
import { useCustomerGroupBuilderForm } from '../../hooks/use-customer-group-builder-form';
import {
  SettingOrderQuantityLimitsSchema,
  type SettingOrderQuantityLimitsState,
} from '../../types/customer-group.schema';
import { ResetSettingsButton } from './reset-settings-button';

export function OrderQuantityLimitCard() {
  const form = useCustomerGroupBuilderForm();
  return (
    <Card showBorder>
      <Card.Header collapsible headingLevel="h2" icon="cube">
        {SETTING_KEY_TO_LABEL.orderItemQuantityValidation}
      </Card.Header>
      <Card.Body>
        <Text variant="secondary">
          {t('features:customer_group.components.order_quantity_limit_card.description')}{' '}
          <LearnMoreLink link="https://docs.sparklayer.io/customers#HfiQ1" />
        </Text>
        <fieldset className="flex flex-col justify-between gap-3 *:flex-1 sm:flex-row">
          <legend className="sr-only">
            {t('features:customer_group.components.order_quantity_limit_card.range')}
          </legend>
          {Object.keys(SettingOrderQuantityLimitsSchema.shape).map((key) => (
            <form.Field
              key={key}
              name={`settings.orderItemQuantityValidation.${key as keyof SettingOrderQuantityLimitsState}`}
            >
              {(field) => (
                <Input
                  id={key}
                  label={t(
                    `features:customer_group.components.order_quantity_limit_card.${key as keyof SettingOrderQuantityLimitsState}.label`,
                  )}
                  placeholder={t(
                    `features:customer_group.components.order_quantity_limit_card.${key as keyof SettingOrderQuantityLimitsState}.placeholder`,
                  )}
                  value={field.state.value ?? ''}
                  error={field.state.meta.errors[0]?.message}
                  onChange={field.handleChange}
                />
              )}
            </form.Field>
          ))}
        </fieldset>
        <div className="flex justify-start">
          <form.Field name="settings.orderItemQuantityValidation">
            {(field) => <ResetSettingsButton field={field} />}
          </form.Field>
        </div>
      </Card.Body>
    </Card>
  );
}
